@if (savedCart$ | async; as cart) {
  @if (cart?.entries?.length > 0) {
    <app-uig-grouped-cart-item-list [cartId]="cart.code" [cartIsLoading]="!(cartLoaded$ | async)"
      [promotionLocation]="CartLocation.SavedCart" [savedCarts]="true" [readonly]="isRestricted"
    [vendorEntryGroups]="(vendorEntryGroups$ | async)" [savedCart]="true"></app-uig-grouped-cart-item-list>
  } @else {
    <ng-template [ngTemplateOutlet]="emptyCartItems"></ng-template>
  }
}
<ng-template #totalHeader>
  <div class="cx-item-list-total">
    {{ 'uigCartItems.total' | cxTranslate }}
  </div>
</ng-template>